/*
 * Desktop - PDP - Image Carousel  --  variant: Size Reduction And Move Small Carousel
 * Moonshot experiment id: 13899706   status in Moonshot on 2026-08-27: DEPLOYED   started: 2025-12-04
 * Audience: DESKTOP   Target: pdp   (see MGExp.targets in mg-exp-runtime.js)
 * Source: verbatim variant code from cdn.moonshot-ai.com/snippets/36780565.js (prettified);
 *         only change is window.msaiTools._msaiRunVariantBlock -> MGExp.runVariantBlock.
 * Enabled by theme setting: mgexp_pdp_d_image_carousel
 */
MGExp.run('pdp_d_image_carousel', { name: "Desktop - PDP - Image Carousel / Size Reduction And Move Small Carousel", platform: 'desktop', target: 'pdp' }, function () {
  !(function () {
    let t = [],
      e = [];
    t.push(".product-image-column div.dc-scroll-snap-align-center");
    !(async function (n, i, a, o, c) {
      let s = {
        multi_target_selectors: t,
        page_identifier_selector: "body.template-product",
        exclude_from_timeout: e,
        selector_timeout: 5e3,
      };
      await MGExp.runVariantBlock(n, i, a, o, c, s);
    })(
      [".dc-scroll-x-manditory"],
      ".msai-image-carousel-update",
      function (t, e) {
        const [n] = e;
        n.classList.add("msai-image-carousel-update");
      },
      "\n.product-image-column div.dc-scroll-snap-align-center {\n  height: calc(100vh - 208px);\n}\n.thumbs.hidden {\n  top: 0 !important;\n  padding-top: 0 !important;\n}\n",
    );
  })();
});
